import type { SVGProps } from "react";

import { cn } from "../../utils";
import { LoaderIcon } from "../icons";

export interface LoadingIndicatorProps {
  className?: string;
}

const LoadingIndicator = (props: SVGProps<SVGSVGElement>) => (
  <LoaderIcon {...props} className={cn("size-6 animate-spin text-primary-50", props.className)} />
);

export default LoadingIndicator;
